// src/api/createApi.js
import axios from 'axios';
import { attachAuthInterceptors } from './attachInterceptors';


export const createApi = (baseURL, logout = null) => {
  const instance = axios.create({
    baseURL,
    headers: { 'Content-Type': 'application/json' },
  });

  attachAuthInterceptors(instance, logout);
  return instance;
};
